
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import draggable from "vuedraggable";
import t from "@common/src/i18n/t";

const dashboard = namespace("dashboard");

@Component({
  components: { draggable }
})
export default class CustomeShortcut extends Vue {
  @dashboard.Action queryAllAndCostomFeature;
  @dashboard.Action saveCustomFeature;
  @Prop({ default: false, type: Boolean })
  visible: boolean;
  created() {
    // this.init();
  }
  init() {
    this.queryAllAndCostomFeature().then(data => {
      this.selectedFeatureList = (data.data?.selectedOptionList || []).map(item => {
        item.pictureUrl = `https://static.gtech.asia/static/speedbiz/quick_entry/icon/pc/${item.iconCode}.png`;
        return item;
      });
      const selectedCodeArr = this.selectedFeatureList.map(selectedItem => {
        this.setFeatureStatus(selectedItem, "isRemovable");
        return selectedItem.resourceCode;
      });
      this.allFeatureList = (data.data?.optionList || [])
        .map(categoryItem => {
          if (!categoryItem.optionList || categoryItem.optionList.length < 1) {
            categoryItem.hide = true;
          } else {
            categoryItem.optionList.forEach(item => {
              if (selectedCodeArr.includes(item.resourceCode)) {
                this.setFeatureStatus(item, "isNotSelectable");
              } else {
                this.setFeatureStatus(item, "isSelectable");
              }
              item.pictureUrl = `https://static.gtech.asia/static/speedbiz/quick_entry/icon/pc/${item.iconCode}.png`;
            });
          }
          return categoryItem;
        })
        .filter(categoryItem => categoryItem.hide !== true);
    });
  }
  selectedFeatureList: any = [];
  allFeatureList: any = [];
  get dragOptions() {
    return {
      animation: 300,
      group: "description",
      disabled: false,
      delay: 0,
      forceFallback: true,
      dragClass: "draging-class"
    };
  }
  drag = false;
  handleAddFeature(item) {
    if (this.selectedFeatureList.length >= 8) {
      return this.$message.error(t("v216_6.add-up-to-8"));
    }
    this.setFeatureStatus(item, "isRemovable");
    this.selectedFeatureList.push(item);
  }
  handleRemoveFeature(item, index) {
    if (this.selectedFeatureList.length <= 1) {
      return this.$message.error(t("v216_6.keep-at-least-one"));
    }
    const allFind = this.allFeatureList
      .map(item => item.optionList)
      .flat()
      .find(allItem => item.resourceCode === allItem.resourceCode);
    this.setFeatureStatus(allFind, "isSelectable");
    this.selectedFeatureList.splice(index, 1);
  }

  setFeatureStatus(item, prop: "isSelectable" | "isNotSelectable" | "isRemovable") {
    item.isSelectable = false;
    item.isNotSelectable = false;
    item.isRemovable = false;
    item[prop] = true;
  }
  handleConfirm() {
    this.$emit("confirm", this.selectedFeatureList);
  }
  handleCancel() {
    this.$emit("update:visible", false);
  }
  @Watch("visible")
  visibleChange(val) {
    if (val) {
      this.init();
    }
  }
}
